// assets
import TopicIcon from '@mui/icons-material/Topic';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import InventoryIcon from '@mui/icons-material/Inventory';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const projects = {
  id: 'my-projects',
  title: 'Mis Proyectos',
  type: 'group',
  children: [
    {
      id: 'projects',
      title: 'Mis Proyectos',
      type: 'item',
      url: '/projects',
      icon: TopicIcon,
      breadcrumbs: false
    },
    {
      id: 'approve',
      title: 'Mis Aprobados',
      type: 'item',
      url: '/approve',
      icon: FactCheckIcon,
      breadcrumbs: false
    },
    {
      id: 'pending',
      title: 'Mis Pendientes',
      type: 'item',
      url: '/pending',
      icon: PendingActionsIcon,
      breadcrumbs: false
    },
    {
      id: 'rejected',
      title: 'Mis Rechazados',
      type: 'item',
      url: '/rejected',
      icon: ThumbDownIcon,
      breadcrumbs: false
    },
    {
      id: 'archived',
      title: 'Mis Archivados',
      type: 'item',
      url: '/archived',
      icon: InventoryIcon,
      breadcrumbs: false
    }
  ]
};

export default projects;
